import React, { forwardRef } from 'react';

const PreviewImages = forwardRef(
  (
    {
      title = '',
      name = 'address_proof',
      data = [],
      handleRemoveFile = () => null,
      handleChangeFile = () => null,
      isLoading = false,
    },
    ref,
  ) => {
    return (
      <div className="form-group">
        <label className="labelMove">{title}</label>{' '}
        {data?.length === 0 && <span>N/A</span>}
        <div className="gutter-2 d-flex flex-wrap">
          {data && Array.isArray(data) && data.length > 0
            ? data.map((file, index) => {
                return (
                  <div
                    key={index}
                    style={{
                      position: 'relative',
                      background: '#f5f5f5',
                      padding: '5px',
                      borderRadius: '5px',
                    }}
                  >
                    <span
                      style={{
                        position: 'absolute',
                        right: '-4px',
                        top: '-5px',
                        cursor: 'pointer',
                        background: '#ddd',
                        width: '16px',
                        height: '16px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderRadius: '100px',
                        fontSize: '8px',
                        border: '1px solid #fff',
                      }}
                      onClick={() => handleRemoveFile(index, name)}
                    >
                      X
                    </span>
                    <img
                      src={file}
                      style={{
                        height: '8rem',
                        width: '100%',
                      }}
                    />
                  </div>
                );
              })
            : null}
        </div>
        <div className="d-flex justify-content-end">
          <input
            ref={ref}
            type="file"
            name={name}
            onChange={(event) => handleChangeFile(event, name)}
            hidden
            multiple
          />
          <button
            type="button"
            className="btn btn-warning mt-2"
            onClick={() => ref?.current?.click()}
            disabled={isLoading === name}
          >
            {isLoading === name
              ? 'Please wait...'
              : `${data?.length > 0 ? 'Change' : 'Add'}`}
          </button>
        </div>
      </div>
    );
  },
);

export default PreviewImages;
